import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { axiosInstance } from "./axiosInstance";
export const login = async (data) => {
  const auth = getAuth();
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      data.email,
      data.password
    );
    if (userCredential && userCredential.user) {
      const token = await userCredential.user.getIdToken();
      sessionStorage.setItem("idToken", token);
      const loggedUser = (await axiosInstance.get("user/me")).data;
      if (loggedUser && ![2,3,4].includes(loggedUser.data.role_id) ) {
        logOut();
        return null;
      }
      sessionStorage.setItem("idToken", token);
      return loggedUser;
    }
  } catch (error) {
    logOut();
    return null;
  }
};

export const getLoggedUser = async () => {
  try {
    const loggedUser = (await axiosInstance.get("user/me")).data;
    if (loggedUser && loggedUser.data.role_id === 1) {
      logOut();
      return null;
    }
    return loggedUser;
  } catch (error) {
    logOut();
    return null;
  }
};

export const logOut = () => {
  const auth = getAuth();
  signOut(auth);
  sessionStorage.removeItem("idToken");
};
